import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=5cb90438&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=5cb90438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb90438",
  null
  
)

export default component.exports